var GoeHistoryChecklistController = (function () {
    function GoeHistoryChecklistController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.ANSWER_OPTIONS = ['Yes', 'No', 'Not Available'];
        this.component = 'goeHistoryChecklist';
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.component) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.component);
            }
        });
    }
    GoeHistoryChecklistController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.component);
    };
    GoeHistoryChecklistController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.component], 'Updating')) {
                var updateObject = {
                    data: {
                        goeHistoryChecklist: {
                            add: true,
                            data: this.topic.temp.goeHistoryChecklist
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goeHistoryChecklist']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.component);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.component);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.component);
        }
    };
    GoeHistoryChecklistController.$inject = ['topic', '$scope'];
    return GoeHistoryChecklistController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistoryChecklist', new GoeHistoryChecklistComponent());

//# sourceMappingURL=goeHistoryChecklistController.js.map
